import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Home from './Home';
import InboundDetails from './InboundDetails';
import OrderList from './OrderList';
import Login from './Login';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/auth/realms/seller/protocol/openid-connect/auth" />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/auth/realms/seller/protocol/openid-connect/auth" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard/KR" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/dashboard/KR" />} />
      <Route path="/scm/receive/detail" element={<ProtectedRoute><InboundDetails /></ProtectedRoute>} />
      <Route path="/scm/order/list" element={<ProtectedRoute><OrderList /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Router basename="/">
          <AppRoutes />
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
